import type { RouteRecordRaw } from 'vue-router'

import { registerWorkflowMessages } from './i18n'

import { useLocaleStore } from '@/shared/i18n'

export const WORKFLOW_ROUTE = { name: 'WorkflowCreate' } as const

/** Native replacement for v3's public AI Workflows entry. */
export const workflowRoutes: RouteRecordRaw[] = [
  {
    path: 'ai-workflows',
    name: WORKFLOW_ROUTE.name,
    component: () => import('./components/WorkflowHubPage.vue'),
    meta: {
      requiresAuth: true,
      permission: 'workflow',
      navKey: 'workflow',
      titleKey: 'workflow.hub.title',
      contentInset: 'none',
    },
    beforeEnter: () => registerWorkflowMessages(useLocaleStore().locale),
  },
]
